import { createSafeHTMLString, ISafeHTMLString } from '../SafeHTML';
import { getAppConfig } from '../../config';

export interface IVendorSearchModeText {
    label: string;
    searchVendorsText: string;
    searchSuppliersText: string;
    searchCloudCaptureText: string;
    searchMissingInfoText: string;
    tooltipBase: {
        vendorFeed: string;
        connectedSuppliers: string;
    };
    tooltipFragments: {
        cloudCapture: string;
        missingInfo: string;
    };
    tooltip: ISafeHTMLString | undefined;
    tooltipWithCloudCapture: ISafeHTMLString | undefined;
    buildTooltip: (options: {
        includeCloudCapture?: boolean;
        includeMissingInfo?: boolean;
    }) => ISafeHTMLString | undefined;
}

function getTooltip(tooltip: string) {
    if (!tooltip) {
        return undefined;
    }

    // eslint-disable-next-line rulesdir/no-create-safe-html-without-reason
    return createSafeHTMLString(tooltip);
}

function buildDynamicTooltip(
    tooltipBase: { vendorFeed: string; connectedSuppliers: string },
    tooltipFragments: { cloudCapture: string; missingInfo: string },
    options: { includeCloudCapture?: boolean; includeMissingInfo?: boolean }
) {
    const fragments = [tooltipBase.vendorFeed, tooltipBase.connectedSuppliers];

    if (options.includeCloudCapture) {
        fragments.push(tooltipFragments.cloudCapture);
    }

    if (options.includeMissingInfo) {
        fragments.push(tooltipFragments.missingInfo);
    }

    return getTooltip(fragments.join(''));
}

export function getVendorSearchModeText(): IVendorSearchModeText {
    const text = getAppConfig().configurableMessages.vendorSearchModeText;

    return {
        ...text,
        tooltip: getTooltip(text.tooltip),
        tooltipWithCloudCapture: getTooltip(text.tooltipWithCloudCapture),
        buildTooltip: (options) => buildDynamicTooltip(text.tooltipBase, text.tooltipFragments, options),
    };
}
